import React, { useState } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import {updateProjectDetails} from '../../api';
import {Form} from "react-bootstrap";
import SpinnerNew from "../Spinner/SpinnerNew";

function PCContractorDialog({contractors, onClose, project, setTempProject }) {

    const [pcContractor, setPCContractor] = useState(project.pcContractor);
    const [spinnerOn, setSpinnerOn] = useState(false);

    function handlePCChange(e)
    {
        const selection = e.currentTarget.value;
        setPCContractor(selection);
    }

    return (
        <div className='react-confirm-alert-body'>
            <SpinnerNew display={spinnerOn}/>
            <div className='edit-dialog--task'>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        Please select the P&C Contractor on this project.
                    </Col>
                </Row>
                <br/>
                <Row style={{ textAlign: 'left' }}>
                    <Col xs={10} md={10} lg={10}>
                        <Form.Control as='select' id='pc_contractor-selector' value={pcContractor} onChange={handlePCChange}>
                            <option  value={''}>{''}</option>
                            {contractors.map((c,index) => (
                                    <option  value={c.pcContractor}>{c.pcContractor}</option>
                                )
                            )}
                        </Form.Control>
                    </Col>
                </Row>
            </div>
            <br />
            <Row style={{ textAlign: 'left' }}>
                <Col xs={8} md={8} lg={8}>
                    <button disabled={pcContractor===null}
                            className='btn btn-primary start-5'
                            onClick={async () => {
                                const newAttributes = {pcContractorSelected:  1, pcContractor: pcContractor};
                                const updatedProject = {...project, ...newAttributes };
                                setSpinnerOn(true);
                                let saveProject = await updateProjectDetails(updatedProject);
                                setSpinnerOn(false);
                                setTempProject(saveProject);
                                onClose();
                            }}
                    >
                        Save
                    </button>
                    <button disabled={false}
                            className='btn btn-primary start-5'
                            onClick={() => {
                               onClose();
                            }}
                    >
                        Cancel
                    </button>
                </Col>
             </Row>
        </div>
    );
}

export default PCContractorDialog;
